module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "transfer-operation list-unstyled"
  }, [_c('li', [_c('t-button', {
    attrs: {
      "type": _vm.rightButtonType,
      "disabled": !_vm.rightActive,
      "size": "sm"
    },
    on: {
      "click": _vm.$_onLeftButtonClick
    }
  }, [(_vm.operations.length <= 0) ? [_vm._v("<")] : [_vm._v(_vm._s(_vm.operations[0]))]], 2)], 1), _vm._v(" "), _c('li', [_c('t-button', {
    attrs: {
      "type": _vm.leftButtonType,
      "disabled": !_vm.leftActive,
      "size": "sm"
    },
    on: {
      "click": _vm.$_onRightButtonClick
    }
  }, [(_vm.operations.length <= 0) ? [_vm._v(">")] : [_vm._v(_vm._s(_vm.operations[1]))]], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3daaae18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transfer/operation.vue
// module id = 361
// module chunks = 0